import React from 'react';
import {
    Button,
    Chip,
    CircularProgress,
    Grid,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    withStyles
} from "material-ui";
import {connect} from "react-redux";
import {
    closeGetReportRegulationFetch,
    closeGetReportTaskFetch,
    getReportRegulation,
    getReportTask,
    reportInitialize
} from "../../redux/actions/reports";
import {Companies} from "../../components/companies";
import Moment from 'react-moment';
import {closeGetCompanyDateFetch, getCompanyDates} from "../../redux/actions/companies";

export class ReportComponent extends React.Component {

    state = {
        date: '',
        companyId: 0,
    };

    dateChange = event => {
        this.setState({[event.target.name]: event.target.value});
        if (!this.props.currentUser.is_admin) {
            this.props.getReportRegulation(this.props.currentUser.company_id, event.target.value);
            this.props.getReportTask(this.props.currentUser.company_id, event.target.value);
        } else {
            this.props.getReportRegulation(this.state.companyId, event.target.value);
            this.props.getReportTask(this.state.companyId, event.target.value);
        }
    };

    componentDidMount = () => {
        document.title = 'レポート | 三島事務所';

        this.props.reportInitialize();

        if (!this.props.currentUser.is_admin) {
            this.props.getCompanyDates(this.props.currentUser.company_id, () => {
                this.setState({
                    date: this.props.dates[0],
                    companyId: this.props.currentUser.company_id,
                });
                this.props.getReportRegulation(this.props.currentUser.company_id, this.props.dates[0]);
                this.props.getReportTask(this.props.currentUser.company_id, this.props.dates[0]);
            });
        }
    };

    /**
     * 顧客選択
     * @param company
     */
    onCompanySelect = (company) => {
        this.props.getCompanyDates(company.id, () => {
            this.setState({
                date: this.props.dates[0],
                companyId: company.id
            });
            this.props.getReportRegulation(company.id, this.props.dates[0]);
            this.props.getReportTask(company.id, this.props.dates[0]);
        });
    };

    goToTask = (task) => {
        this.props.history.push(`/task/${task.id}`);
    };

    render() {

        const {
            classes, currentUser, isGetReportRegulationFetch, isGetReportTaskFetch,
            regulations, tasks, dates
        } = this.props;

        const {date, companyId} = this.state;

        return (
            <div className={classes.root}>

                {currentUser.is_admin ?
                    <Companies
                        onCompanySelect={this.onCompanySelect}/> : null}

                <Paper className={classes.mainContainer}>

                    <Grid container>
                        <Grid item>
                            <Select
                                name="date"
                                value={this.state.date}
                                onChange={this.dateChange}
                                inputProps={{
                                    date: dates[0],
                                }}>
                                {dates.map((n, index) => {
                                    return <MenuItem value={n} key={index}>
                                        <Moment format="YYYY年MM月">{n}</Moment>
                                    </MenuItem>
                                })}
                            </Select>
                        </Grid>

                        <Grid item>
                            {!isGetReportRegulationFetch ?
                                <Button variant="raised" color="primary"
                                        href={`${process.env.REACT_APP_API_URL}/companies/${companyId}/pdf?view=pdf&date=${date}`}
                                        target="_blank">
                                    PDFダウンロード
                                </Button>
                                :
                                <Button variant="raised" color="primary" disabled>
                                    PDFダウンロード
                                </Button>}
                        </Grid>
                    </Grid>


                    <Typography variant="title" className={classes.subtitle}>法令チェック</Typography>

                    {!isGetReportRegulationFetch && regulations.length === 0 ? 'レポートが登録されていません' :
                        <div>
                            {isGetReportRegulationFetch ? <CircularProgress/> :
                                <div>

                                    <Paper className={classes.container}>
                                        <div>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className={classes.statusCell}> </TableCell>
                                                        <TableCell>項目名</TableCell>
                                                        <TableCell>最終更新日</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {regulations.map((n) => {
                                                        return (
                                                            <TableRow key={n.id}
                                                                      className={n.status === 3 ? classes.danger : ''}>
                                                                <TableCell>
                                                                    {n.status === 1 ?
                                                                        <Chip label="未対応"
                                                                              className={classes.chip}/> : ''}
                                                                    {n.status === 2 ?
                                                                        <Chip label="適正"
                                                                              className={classes.chip}/> : ''}
                                                                    {n.status === 3 ?
                                                                        <Chip label="不適正"
                                                                              className={classes.chip}/> : ''}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {n.regulation.name}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Moment
                                                                        format="YYYY年MM月DD日">{n.updated_at}</Moment>
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </Paper>
                                </div>
                            }
                        </div>
                    }


                    <Typography variant="title" className={classes.subtitle}>課題進捗</Typography>

                    {!isGetReportTaskFetch && tasks.length === 0 ? 'レポートが登録されていません' :
                        <div>
                            {isGetReportTaskFetch ? <CircularProgress/> :
                                <div>

                                    <Paper className={classes.container}>
                                        <div>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className={classes.statusCell}> </TableCell>
                                                        {/*<TableCell className={classes.statusCell}> </TableCell>*/}
                                                        <TableCell>項目名</TableCell>
                                                        <TableCell>更新内容</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tasks.map((n) => {
                                                        return (
                                                            <TableRow key={n.id}
                                                                      onClick={this.goToTask.bind(this, n)}
                                                                      hover
                                                                      className={classes.clickable}>
                                                                <TableCell>
                                                                    {n.status === 1 ?
                                                                        <Chip label="オープン"
                                                                              className={classes.chip}/> : ''}
                                                                    {n.status === 2 ?
                                                                        <Chip label="クローズ"
                                                                              className={classes.chip}/> : ''}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {n.name}
                                                                </TableCell>
                                                                <TableCell>
                                                                    <div>{n.posts.length}件のやり取りがありました</div>
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </Paper>
                                </div>
                            }
                        </div>
                    }

                </Paper>
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        display: 'flex',
        height: 'calc(100vh - 64px)',
        position: 'relative',
    },
    mainContainer: {
        background: '#fbfbfb',
        zIndex: 1,
        width: '100%',
        // height: '100%',
        position: 'relative',
        overflow: 'auto',
        padding: theme.spacing.unit * 3,
    },
    chip: {
        margin: theme.spacing.unit,
    },
    statusCell: {
        width: 80
    },
    subtitle: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 2,
    },
    danger: {
        background: '#f5cecd',
    },
    clickable: {
        cursor: 'pointer'
    }
});

ReportComponent = withStyles(styles)(ReportComponent);
ReportComponent = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser,
            isGetReportRegulationFetch: state.reports.isGetReportRegulationFetch,
            isGetReportTaskFetch: state.reports.isGetReportTaskFetch,
            regulations: state.reports.regulations,
            tasks: state.reports.tasks,
            dates: state.companies.dates,
        }
    },
    (dispatch) => {
        return {

            reportInitialize: () => {
                dispatch(reportInitialize());
            },

            getCompanyDates: (companyId, callback) => {
                dispatch(getCompanyDates(companyId)).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetCompanyDateFetch());
                        callback();
                    });
                });
            },

            getReportRegulation: (companyId, date) => {
                dispatch(getReportRegulation(companyId, date)).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetReportRegulationFetch());
                    }, 300);
                });
            },

            getReportTask: (companyId, date) => {
                dispatch(getReportTask(companyId, date)).then(() => {
                    setTimeout(() => {
                        dispatch(closeGetReportTaskFetch());
                    }, 300);
                });
            },
        }
    }
)(ReportComponent);


// WEBPACK FOOTER //
// ./src/containers/report/index.js